/* tc.js  -  /pages/treat-calculator
   NO FEEDING FORMULA LIVES HERE and NO AGE OR ACTIVITY MAP LIVES HERE.
   window.wynProfile.toPlan() shapes the dog, window.wynFeed.maintenanceKcal does
   the calories. The only arithmetic added is the treat ceiling and the label
   conversion, which is unit arithmetic rather than nutrition.

   THIS PAGE IS READ ONLY ON DOG DATA. There is no `.set(` in this file. It reads
   the shared profile and never writes to it. Its own storage key is wyn_treats
   and it never touches wyn_dog or wyn_dogs. */
(function () {
  'use strict';

  function $(id) { return document.getElementById(id); }
  function show(el, yes) { if (el) { if (yes) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }
  function txt(el, s) { if (el) el.textContent = s; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function r0(n) { return Math.round(n); }
  function r1(n) { return Math.round(n * 10) / 10; }

  var BOOT = {};
  try { BOOT = JSON.parse(($('tc-boot') || {}).textContent || '{}'); } catch (e) { BOOT = {}; }
  var C = BOOT.copy || {};

  var LIB_OK = !!(window.wynFeed && typeof window.wynFeed.maintenanceKcal === 'function');
  var MOD = (window.wynProfile && typeof window.wynProfile.get === 'function') ? window.wynProfile : null;
  var HAS_TOPLAN = !!(MOD && typeof MOD.toPlan === 'function');

  /* THE TREAT LIST LIVES IN assets/treats.js AND NOWHERE ELSE, shared with the
     picky eater guide. This page must not carry its own copy. */
  var TR = (window.wynTreats && window.wynTreats.ours) ? window.wynTreats : null;
  var PCT = (TR && TR.treat_pct) || 10;
  var TKEY = 'wyn_treats';
  var WT = BOOT.weight_default || 35;   /* only until a real dog turns up */
  var DOG = null;                        /* the shared profile, read only */
  var COUNTS = {};                       /* id -> how many today */
  var MINE = [];                         /* the customer's own treats */

  /* ---------------- the dog ----------------
     CALORIES ARE A PROPERTY OF THE DOG. maintenanceKcal needs no diet, so this
     page asks for no diet and loads no diets.json. */
  function readBus() {
    if (!MOD) return;
    var d = null;
    try { d = MOD.get(); } catch (e) { d = null; }
    DOG = d || null;
    if (DOG && DOG.weight_lb > 0) WT = Number(DOG.weight_lb);
  }
  function libProfile() {
    if (HAS_TOPLAN && DOG) {
      var p = null;
      try { p = MOD.toPlan(); } catch (e) { p = null; }
      if (p) { p = Object.assign({}, p); p.weight_lb = WT; return p; }
    }
    /* No module, or nothing stored. Weight only; the library supplies every
       other default itself, which is why no map is duplicated here. */
    return { weight_lb: WT };
  }
  function dayKcal() {
    if (!LIB_OK) return 0;
    try { return window.wynFeed.maintenanceKcal(libProfile()) || 0; } catch (e) { return 0; }
  }
  function dogKey() {
    if (DOG && DOG.rosterId) return 'r:' + DOG.rosterId;
    if (DOG && DOG.name) return 'n:' + String(DOG.name).toLowerCase();
    return 'local';
  }

  /* ---------------- the customer's own treats ---------------- */
  function load() {
    var all = { v: 1, dogs: {} };
    try {
      var raw = localStorage.getItem(TKEY);
      if (raw) { var j = JSON.parse(raw); if (j && j.dogs) all = j; }
    } catch (e) { }
    return all;
  }
  function save(list) {
    var all = load();
    all.dogs[dogKey()] = { items: list, updated: Date.now() };
    try { localStorage.setItem(TKEY, JSON.stringify(all)); } catch (e) { }
  }
  function mine() {
    var rec = load().dogs[dogKey()];
    return (rec && rec.items) ? rec.items : [];
  }

  /* ---------------- the label conversion ----------------
     AAFCO requires the calorie statement in kcal/kg AND per familiar unit, so a
     bag usually prints both. Per treat is taken straight; every other form is a
     density and needs the weight of one treat. */
  var G_PER_OZ = 28.349523125;
  function perTreat(amount, unit, size, sizeUnit) {
    var a = Number(amount);
    if (!isFinite(a) || a <= 0) return null;
    if (unit === 'each') return a;
    var g = Number(size);
    if (!isFinite(g) || g <= 0) return null;
    if (sizeUnit === 'oz') g = g * G_PER_OZ;
    if (unit === 'kg') return a * g / 1000;      /* kcal per kg */
    if (unit === 'hundred') return a * g / 100;  /* kcal per 100 g */
    return null;
  }
  function needsSize(unit) { return unit !== 'each'; }

  function readForm() {
    return {
      name: ($('tc-a-name') || {}).value || '',
      amount: ($('tc-a-amt') || {}).value || '',
      unit: ($('tc-a-unit') || {}).value || 'each',
      size: ($('tc-a-size') || {}).value || '',
      sizeUnit: ($('tc-a-sizeunit') || {}).value || 'g'
    };
  }
  function renderForm() {
    var f = readForm();
    show($('tc-a-sizewrap'), needsSize(f.unit));
    var k = perTreat(f.amount, f.unit, f.size, f.sizeUnit);
    var out = $('tc-a-out');
    if (k == null) {
      out.className = 'tc-out tc-out--bad';
      txt(out, f.amount ? (C.add_need || '') : '');
    } else {
      out.className = 'tc-out';
      txt(out, fill(C.add_each, { n: k < 10 ? r1(k) : r0(k) }));
    }
  }
  function addTreat() {
    var f = readForm();
    var k = perTreat(f.amount, f.unit, f.size, f.sizeUnit);
    if (k == null || !f.name.trim()) return;
    var list = mine();
    list.push({ id: 'm' + Date.now(), name: f.name.trim().slice(0, 60), kcal: Math.round(k * 10) / 10 });
    save(list);
    $('tc-a-name').value = ''; $('tc-a-amt').value = ''; $('tc-a-size').value = '';
    renderAll();
  }
  function delTreat(id) {
    save(mine().filter(function (t) { return t.id !== id; }));
    delete COUNTS[id];
    renderAll();
  }

  /* ---------------- everything countable, ours and theirs ---------------- */
  function countable() {
    return (TR ? TR.ours.concat(TR.common) : []).concat(MINE);
  }
  function usedKcal() {
    var all = countable(), t = 0, i;
    for (i = 0; i < all.length; i++) t += (COUNTS[all[i].id] || 0) * all[i].kcal;
    return t;
  }

  function fill(s, map) {
    return String(s || '').replace(/\{(\w+)\}/g, function (m, k) {
      return (map && map[k] != null) ? String(map[k]) : '';
    });
  }

  /* ---------------- rendering ---------------- */
  function rows(list, wrapId, own) {
    var w = $(wrapId);
    if (!w) return;
    var h = '', i, t;
    for (i = 0; i < list.length; i++) {
      t = list[i];
      h += '<div class="tc-row" data-id="' + esc(t.id) + '">' +
        '<span class="tc-row__n">' + esc(t.name) + '</span>' +
        '<span class="tc-row__k">' + (t.kcal < 10 ? r1(t.kcal) : r0(t.kcal)) + esc(C.each_kcal || ' kcal') + '</span>' +
        '<span class="tc-step">' +
        '<button type="button" data-d="-1" aria-label="' + esc(C.less || 'One fewer') + '"><span class="tc-ic"></span></button>' +
        '<input type="number" inputmode="numeric" min="0" max="99" value="' + (COUNTS[t.id] || 0) + '" data-n="' + esc(t.id) + '">' +
        '<button type="button" data-d="1" aria-label="' + esc(C.more || 'One more') + '"><span class="tc-ic tc-ic--plus"></span></button>' +
        '</span>' +
        (own ? '<button type="button" class="tc-del" data-x="' + esc(t.id) + '">' + esc(C.remove || 'Remove') + '</button>' : '') +
        '</div>';
    }
    w.innerHTML = h;
  }

  function paint() {
    var full = dayKcal();
    var cap = full * PCT / 100;
    var used = usedKcal();

    show($('tc-broken'), !LIB_OK || !TR);
    show($('tc-tool'), LIB_OK && !!TR);
    /* Name the file. "One file did not save" cost a round trip once. */
    if (!LIB_OK || !TR) txt($('tc-broken-file'), !LIB_OK ? 'wynfeed.js' : 'treats.js');

    txt($('tc-day'), full ? r0(full).toLocaleString() : '--');
    txt($('tc-cap'), cap ? r0(cap).toLocaleString() : '--');
    txt($('tc-capmini'), cap ? r0(cap).toLocaleString() : '--');
    txt($('tc-used'), r0(used).toLocaleString());
    var st = $('tc-sticky');
    if (st) st.className = 'tc-sticky' + (cap > 0 && used > cap ? ' is-over' : (used > 0 ? ' is-on' : ''));

    var pct = cap > 0 ? Math.min(100, used / cap * 100) : 0;
    var bar = $('tc-bar');
    if (bar) {
      bar.className = 'tc-bar' + (cap > 0 && used > cap ? ' tc-bar--over' : '');
      $('tc-bar-f').style.width = pct + '%';
    }

    /* the row you just tapped has to change, not only the total at the bottom */
    var all = countable(), i, cell, n;
    for (i = 0; i < all.length; i++) {
      n = COUNTS[all[i].id] || 0;
      cell = document.querySelector('[data-id="' + all[i].id + '"] .tc-row__k');
      if (cell) {
        cell.textContent = n > 0
          ? (r0(n * all[i].kcal) + (C.each_kcal || '').replace(' each', ''))
          : ((all[i].kcal < 10 ? r1(all[i].kcal) : r0(all[i].kcal)) + (C.each_kcal || ''));
        cell.className = 'tc-row__k' + (n > 0 ? ' is-on' : '');
      }
    }

    /* The bar stays short: a number and a rule until there is something to say.
       The starting instruction sits above the list instead. */
    var v = $('tc-verdict');
    show($('tc-none'), used === 0);
    show(v, used > 0 && cap > 0);
    if (!cap || used === 0) { txt(v, ''); }
    else if (used <= cap) { txt(v, fill(C.v_ok, { left: r0(cap - used) })); }
    else { txt(v, fill(C.v_over, { over: r0(used - cap), pct: r1((used - cap) / full * 100) })); }

  }

  /* Rebuilds the rows. Only call this when the LIST changed, never on a count. */
  function renderAll() {
    MINE = mine();
    rows(TR ? TR.ours : [], 'tc-ours', false);
    rows(TR ? TR.common : [], 'tc-common', false);
    rows(MINE, 'tc-mine', true);
    show($('tc-mine-empty'), MINE.length === 0);
    renderForm();
    paint();
  }

  /* ---------------- wiring ---------------- */
  function wireLedger(wrap) {
    if (!wrap) return;
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-d]') : null;
      if (b) {
        var step = b.parentNode, id = step.parentNode.getAttribute('data-id');
        COUNTS[id] = Math.max(0, Math.min(99, (COUNTS[id] || 0) + parseInt(b.getAttribute('data-d'), 10)));
        var f = step.querySelector('input[data-n]');
        if (f) f.value = COUNTS[id];
        paint();
        return;
      }
      var x = e.target.closest ? e.target.closest('button[data-x]') : null;
      if (x) delTreat(x.getAttribute('data-x'));
    });
    wrap.addEventListener('input', function (e) {
      var n = e.target.getAttribute && e.target.getAttribute('data-n');
      if (!n) return;
      COUNTS[n] = Math.max(0, Math.min(99, parseInt(e.target.value, 10) || 0));
      paint();
    });
  }

  function boot() {
    readBus();
    var w = $('tc-wt');
    if (w) {
      w.value = r0(WT);
      w.addEventListener('input', function () {
        var v = parseFloat(w.value);
        if (isFinite(v) && v > 0) { WT = v; paint(); }
      });
    }
    wireLedger($('tc-ours'));
    wireLedger($('tc-common'));
    wireLedger($('tc-mine'));
    ['tc-a-amt', 'tc-a-unit', 'tc-a-size', 'tc-a-sizeunit'].forEach(function (id) {
      var el = $(id);
      if (el) el.addEventListener('input', renderForm);
      if (el && el.tagName === 'SELECT') el.addEventListener('change', renderForm);
    });
    var add = $('tc-a-go');
    if (add) add.addEventListener('click', addTreat);

    renderAll();

    /* another surface changed the dog while this page is open */
    if (MOD && typeof MOD.subscribe === 'function') {
      try { MOD.subscribe(function () { readBus(); if ($('tc-wt')) $('tc-wt').value = r0(WT); renderAll(); }); } catch (e) { }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();